import { createState } from "@/state.init";
import { SEED } from "./models";

export const state = createState("shared", SEED);
